import React from 'react';
import { Box, Typography, Card, Chip } from '@mui/material';
import TopicIcon from '@mui/icons-material/Topic';

export default function TopicSubtopicsSidebar({
  subtopics = [],
  selected = [],
  onSelect,
  topicName,
}) {
  const selectedSet = new Set(selected);

  const handleToggle = (id) => {
    if (!onSelect) return;
    if (selectedSet.has(id)) {
      onSelect(selected.filter((s) => s !== id));
    } else {
      onSelect([...selected, id]);
    }
  };

  const selectedSubs = subtopics.filter((s) => selectedSet.has(s.id));
  const unselectedSubs = subtopics.filter((s) => !selectedSet.has(s.id));

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: 2 }}>
        <TopicIcon fontSize="small" color="success" sx={{ mr: 1 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {topicName} Subtopics
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 1.5, rowGap: 1.5, mt: 2, ml: 2, mr: 2 }}>
        {selectedSubs.map((sub) => (
          <Chip
            key={sub.id}
            label={sub.name}
            variant="outlined"
            color="success"
            onDelete={() => handleToggle(sub.id)}
            sx={{
              px: 1,
              py: 2,
              '& .MuiChip-label': { fontSize: '0.85rem', fontWeight: 'normal' },
              '& .MuiChip-deleteIcon': {
                fontSize: '1.2rem', // 👈 Increase size here
              },
            }}
          />
        ))}
        {unselectedSubs.map((sub) => (
          <Chip
            key={sub.id}
            label={sub.name}
            variant="outlined"
            color="success"
            onClick={() => handleToggle(sub.id)}
            sx={{
              backgroundColor: 'transparent',
              px: 1,
              py: 2,
              '& .MuiChip-label': { fontSize: '0.85rem', color: "text.primary", fontWeight: 'normal' },
            }}
          />
        ))}
      </Box>
    </Card>
  );
}
